var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppsstore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 195,
    height: 58,
    viewBox: "0 0 195 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63617",
    "data-name": "Group 63617",
    transform: "translate(-1322 -520)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17537",
    "data-name": "Group 17537",
    transform: "translate(1372 530)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Title_TAG:H1_",
    "data-name": "Title [TAG:H1]",
    transform: "translate(0 11)",
    fontSize: 12,
    fontFamily: "Poppins-Regular, Poppins",
    letterSpacing: "0.006em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Download on the")), /*#__PURE__*/React.createElement("text", {
    id: "Title_TAG:H1_2",
    "data-name": "Title [TAG:H1]",
    transform: "translate(0 12)",
    fontSize: 20,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "App Store"))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1954",
    "data-name": "Rectangle 1954",
    transform: "translate(1322 520)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 58,
    rx: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 194,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-apple",
    "data-name": "Icon awesome-apple",
    d: "M17.21,14.983a5.022,5.022,0,0,1,2.69-4.562,5.78,5.78,0,0,0-4.556-2.4c-1.91-.151-4,1.113-4.761,1.113-.807,0-2.657-1.06-4.11-1.06-3,.048-6.191,2.394-6.191,7.165a13.407,13.407,0,0,0,.775,4.368c.689,1.974,3.174,6.815,5.767,6.735,1.356-.032,2.313-.963,4.077-.963,1.711,0,2.6.963,4.11.963,2.614-.038,4.863-4.438,5.519-6.417a5.332,5.332,0,0,1-3.319-4.943ZM14.165,6.15a5.066,5.066,0,0,0,1.291-3.9A5.7,5.7,0,0,0,11.8,4.127a5.146,5.146,0,0,0-1.377,3.868A4.518,4.518,0,0,0,14.165,6.15Z",
    transform: "translate(1340.536 534.75)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsstore);
export default __webpack_public_path__ + "static/media/appsstore.1562e6a2f728cb7fb00615b55bc4739b.svg";
export { ForwardRef as ReactComponent };